import { configureStore } from "@reduxjs/toolkit";
import constantsReducer from "./constants-slice";

const store = configureStore({
  reducer: {
    constants: constantsReducer,
  },
});

export default store;
